<template>
    <div class="HeadlinesDetailed">
       <div class="HeadlinesDetailed-box">
           <div class="HeadlinesDetailed-box-title">{{title}}</div>
           <div class="HeadlinesDetailed-box-dividing "></div>
           <div class="HeadlinesDetailed-box-text">{{text}}</div>
            <div class="HeadlinesDetailed-box-text">{{text2}}</div>
       </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            img: require('../../lib/image/news/345.png'),
            title:"服务指南",
            time:'2019-11-19',
            num:'115',
            text:"为庆祝海南省博物馆建馆11周年，进一步增强学术氛围，促进学术交流，不断提升学术水平和科研能力，11月18日下午，我馆举行了建馆11周年学术报告会活动。全馆干部职工参加，会议由馆长陈江主持。 会议邀请公共服务部主任宋玉、文物考古工作队何国俊、水下考古研究所中心主任李钊、陈列部馆员黄晶、文物保护与修复部副主任包春磊等5位馆员作大会主旨发言和交流。内容涉及“十一载共成长——“我”与海南省博物馆”“从水会所城到石室仙踪——海南两处明代遗址考古简述”“近年西沙水下考古与文物保护” “灯下故人——一个德国人与海南岛的故事”““华光礁I号”南宋沉船保护历程及现状”等，报告精彩纷呈，学术氛围热烈浓郁。",
            text2:"公共服务部主任宋玉以“十一载共成长——我与海南省博物馆”为题进行学术交流。报告以回忆的方式，利用大量的照片、数字介绍了公共服务部砥砺前行的十一年发展历程，从讲解接待、社会教育、团队建设和培训学习、理念和方法的探索与创新等方面总结公共服务部取得的辉煌成就，全面展示了公共服务部随着海南省博物馆的发展而成长壮大，以及省博物馆发展前景进行了展望。"
        }
    },
    created() {
        
    },
    methods: {
         
    }
}   
</script>

<style lang="less" scoped>
   .HeadlinesDetailed{
       background:#EFF0FA!important;
       padding: 20px 7px 28px 7px;
        .HeadlinesDetailed-box{
            background: url(../../lib/image/news/45671.png) right bottom no-repeat;
            background-size: 262px 180px;
            background-color:rgba(255,255,255,1);
            box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
            border-radius:5px;
            padding: 20px 24px 120px 24px;
            .HeadlinesDetailed-box-title{
                font-size: 16px;
                color:rgba(55,83,106,1);
                line-height: 24px;
                font-weight:500;
                text-align: center;
            }
            .HeadlinesDetailed-box-dividing{
                height: 14px;
                background: url(../../lib/image/IntroductoryArticles/top.png) center no-repeat;
                background-size: 100% 100%;
                margin: 32px 0 24px 0;
            }
            .HeadlinesDetailed-box-text{
                text-align: justify; 
                text-justify: inter-ideograph; 
                text-indent: 2em;
                font-size:12px;
                font-weight:400;
                color:#757C88;
                line-height:24px;
                .HeadlinesDetailed-img{
                    height: 195px;
                    width: 100%;
                }
            }
        }
   }
</style>